<template>
	<button class="btn btn-sm rounded-pill" :class="btnClass" @click.prevent="onClickBtn">
		<span class="va-sub">{{btnText}}</span>
	</button>
</template>

<script>
import PrivateAreaPointsMixin from './mixin/PrivateAreaPointsMixin'
import axios from 'axios'

export default {
	name: 'DownloadPdfComponent',
	props: ['btnClass', 'btnText', 'fileName'],
	mixins: [PrivateAreaPointsMixin],

	data() {
		return {
			ajaxObj: window.ajax_object,
			blobName: ''
		}
	},

	methods: {
		onClickBtn() {
			let url = this.ajaxObj.ajax_url
			axios.get(url,
			{
				params: {
					_nounce_value: this.ajaxObj._nounce_value,
					action: 'nl_download_pdf',
					fileName: this.fileName
				}
			})
			.then((response) => {
				console.log(response.data)
				this.downloadPdf(response.data.url, response.data.file_name)
			})
			.catch((err) => {
				console.log(err)
			})
		},

		downloadPdf(url, fileName) {
			axios.get(url,
				{
					responseType: 'blob',
					headers: {
						'Accept': 'application/pdf'
					}
				})
				.then((response) => {
					const downloadUrl = window.URL.createObjectURL(new Blob([response.data]))
					const link = document.createElement('a')
					link.href = downloadUrl
					link.setAttribute('download', fileName)
					document.body.appendChild(link)
					link.click()
					link.remove()
					// this.pdfDownloaded()
				})
				.catch((err) => {
					console.log(err)
				})
		},

		/*pdfDownloaded() {
			let url = this.ajaxObj.ajax_url

			var formData = new FormData();
			formData.append('action', 'nl_point_action_register')
			formData.append('_nounce_value', this.ajaxObj._nounce_value)
			formData.append('action_type', this.actionType)

			axios.post(url, formData)
				.then(() => {
					// console.log(response.data)
					this.setPrivatAreaPoints()
				}, (error) => {
					console.log(error);
				});
		}*/
	}
}
</script>
